import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import GridViewIcon from "@mui/icons-material/GridView";
// import PeopleIcon from "@mui/icons-material/People";
import { Box, Stack } from "@mui/material";
import { HorizontalNavBar, type HorizontalNavBarProps } from "components/HorizontalNavBar/HorizontalNavBar";
import { Routes } from "constants/routes";

import { Community } from "../Community/Community";
import { Tools } from "../Tools/Tools";

const iconsSx = {
  fontSize: "16px",
  mr: "6px"
};

export const Freemium: React.FC = () => {
  const tabs: HorizontalNavBarProps["tabs"] = [
    {
      label: "Tools",
      value: "tools",
      icon: <GridViewIcon sx={iconsSx} />,
      to: Routes.freemiumTools,
      matchRouts: [Routes.freemiumTools]
    }
    // {
    //   label: "Community",
    //   value: "community",
    //   icon: <PeopleIcon sx={iconsSx} />,
    //   to: Routes.freemiumCommunity,
    //   matchRouts: [Routes.freemiumCommunity]
    // }
  ];

  return (
    <Stack sx={{ width: "100%", overflow: "hidden", p: "1px", gap: "16px" }} alignItems="stretch" direction="column">
      <HorizontalNavBar
        tabs={tabs}
        classes={{
          indicator: "indicator"
        }}
        TabIndicatorProps={{
          children: <span />
        }}
        sx={{
          minHeight: "24px",
          button: {
            p: 0,
            minHeight: "20px",
            fontWeight: "normal",
            color: "#5d7782",
            fontSize: "15px"
          },
          ".MuiTabs-flexContainer": {
            alignItems: "center",
            gap: "15px"
          },
          "& .indicator": {
            display: "flex",
            justifyContent: "center",
            backgroundColor: "transparent",
            "& > span": {
              width: "98%",
              backgroundColor: "#0a3142"
            }
          }
        }}
      />
      <Box overflow="hidden" display="flex" flexGrow={1}>
        <Switch>
          <Redirect exact from={Routes.freemium} to={Routes.freemiumTools} />
          <Route path={Routes.freemiumTools} component={Tools} />
          <Route path={Routes.freemiumCommunity} component={Community} />
        </Switch>
      </Box>
    </Stack>
  );
};
